import $ from 'jquery'
import ChartPDFGenerator from './pdfgenerator/ChartPDFGenerator'
import PDFPreviewController from '../../pdfPreview/PDFPreviewController'
import ChartsPDFSettingsPreview from './pdfSettingsPreview/ChartsPDFSettingsPreview'
import {ReportChartType} from '../constants'
import OvertimeParametersFormattingStrategy from './parametersFormatters/OvertimeParametersFormattingStrategy'
import {getChartImageDimensionsInPixels, getTotalPagesCalculator, getUsersFilteredByAuthorizer} from './pdfgenerator/utils'
import ReportChartsStore from './ReportChartsStore'
import WorkingHoursCostBillingParametersFormattingStrategy from './parametersFormatters/WorkingHoursCostBillingParametersFormattingStrategy'
import BalanceParametersFormattingStrategy from './parametersFormatters/BalanceParametersFormattingStrategy'
import LeaveParametersFormattingStrategy from './parametersFormatters/LeaveParametersFormattingStrategy'

function CreateChartLightboxPDFPreviewViewController() {}

CreateChartLightboxPDFPreviewViewController.prototype = _.create(PDFPreviewController.prototype, {

    init: function(
        lightBoxEl,
        titleEl,
        elementsIdPrefix,
        printParameters,
        switchBackCallback,
        chartController,
        selectorsData,
        includeOtherUsersChecker,
        useStackColumnsChecker,
        reportAuthorizationInfo,) {
        ReportChartsStore.setPrintParametersForSave(printParameters);

        PDFPreviewController.prototype.init.call(this, lightBoxEl, titleEl, elementsIdPrefix);

        this.backToChartParametersBtn = $(document.getElementById( elementsIdPrefix + "_backBtn" ));
        this.backToChartParametersBtn.off();
        this.backToChartParametersBtn.click( switchBackCallback );

        this.pdfGenerator = new ChartPDFGenerator(
            (pdfData) => {
                this.onGeneratePDFCompleted(pdfData)
            }
        )
        this.chartController = chartController;
        this.selectorsData = selectorsData;
        this.includeOtherUsersChecker = includeOtherUsersChecker
        this.useStackColumnsChecker = useStackColumnsChecker
        this.reportAuthorizationInfo = reportAuthorizationInfo

        return this;
    },

    _initPdfSettingsPreview: function(elementsIdPrefix)
    {
        if (!CreateChartLightboxPDFPreviewViewController.pdfSettingsPreview)
        {
            CreateChartLightboxPDFPreviewViewController.pdfSettingsPreview =
                    new ChartsPDFSettingsPreview($(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix).init();
        }
        this.pdfSettingsPreview = CreateChartLightboxPDFPreviewViewController.pdfSettingsPreview;
    },

    _subscribeForEvents: function()
    {
        var self = this;
        $(document).on("reportCharts.intermediatePrintParametersChange", function(event, printParameters)
        {
            ReportChartsStore.setPrintNumberOfPages(self._calculateTotalNumberOfPages(printParameters));
        });
        $(document).on("reportCharts.printParametersForSaveChange", function(event, printParametersForSave)
        {
            ReportChartsStore.setPrintParametersForSave(printParametersForSave);
            self.cancelAllExportingProcesses();
            self.updatePDF();
        });
        $(document).on("reportCharts.createChartLightbox.hide", function()
        {
            $(document)
                    .off("reportCharts.createChartLightbox.hide")
                    .off("reportCharts.intermediatePrintParametersChange")
                    .off("reportCharts.printParametersForSaveChange");
        });
    },

    cancelAllExportingProcesses: function ()
    {
        this.chartController.breakExport();
        this.pdfGenerator.interruptGeneration();
        this.pdfViewer.interruptPreview();
    },

    switchLightboxToPDFPreviewView: function (selectedParameters, chartType, chartDataController)
    {
        this.chartType = chartType;
        this.chartDataController = chartDataController;
        this.selectedParameters = selectedParameters;

        $( this.lightBoxEl ).removeClass("createChartMode").addClass("pdfPreviewMode");

        this._setTitle(
                this.createFormattingStrategy(selectedParameters.chartTypeValue),
                selectedParameters
        );

        this.pdfSettingsPreview.onShow(
            this.chartType,
            this.chartDataController.getCountPoints(),
            this.chartController.getCurrentBarCount(),
            this.chartDataController.getMinValue(),
            this.chartDataController.getMaxValue()
        );

        ReportChartsStore.setPrintNumberOfPages(this._calculateTotalNumberOfPages(this.pdfSettingsPreview.collectPrintParametersForGenerate()));

        this.updatePDF();
    },

    createFormattingStrategy: function(chartTypeValue) {
        let availableUsers;
        switch (chartTypeValue) {
            case ReportChartType.TOTAL_WORKING_HOURS:
            case ReportChartType.APPROVED_WORKING_HOURS:
                availableUsers = getUsersFilteredByAuthorizer(this.selectorsData.users, this.reportAuthorizationInfo.taskChartsAuthorizationInfo)
                return new WorkingHoursCostBillingParametersFormattingStrategy().init({
                    selectorsData: {...this.selectorsData, users: availableUsers},
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.taskChartsAuthorizationInfo,
                })
            case ReportChartType.COST_OF_WORK:
            case ReportChartType.BILLABLE_AMOUNTS:
                availableUsers = getUsersFilteredByAuthorizer(this.selectorsData.users, this.reportAuthorizationInfo.billingChartsAuthorizationInfo)
                return new WorkingHoursCostBillingParametersFormattingStrategy().init({
                    selectorsData: {...this.selectorsData, users: availableUsers},
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.billingChartsAuthorizationInfo,
                })
            case ReportChartType.LEAVE_HOURS:
                availableUsers = getUsersFilteredByAuthorizer(this.selectorsData.users, this.reportAuthorizationInfo.balanceChartsAuthorizationInfo)
                return new LeaveParametersFormattingStrategy().init({
                    selectorsData: {...this.selectorsData, users: availableUsers},
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.balanceChartsAuthorizationInfo,
                })
            case ReportChartType.PTO_BALANCE:
            case ReportChartType.SICK_DAYS_BALANCE:
                availableUsers = getUsersFilteredByAuthorizer(this.selectorsData.users, this.reportAuthorizationInfo.balanceChartsAuthorizationInfo)
                return new BalanceParametersFormattingStrategy().init({
                    selectorsData: {...this.selectorsData, users: availableUsers},
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.balanceChartsAuthorizationInfo,
                })
            case ReportChartType.OVERTIME_HOURS:
                availableUsers = getUsersFilteredByAuthorizer(this.selectorsData.users, this.reportAuthorizationInfo.balanceChartsAuthorizationInfo)
                return new OvertimeParametersFormattingStrategy().init({
                    selectorsData: {...this.selectorsData, users: availableUsers},
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.balanceChartsAuthorizationInfo,
                })
        }
    },

    updatePDF: function(){
        this.disableDownloadPDFButton();
        this.pdfSettingsPreview.beforePreviewUpdate();
        this.pdfViewer.showMoire();

        const printParams = this.pdfSettingsPreview.collectPrintParametersForGenerate();

        this.chartController.exportChart(
            getChartImageDimensionsInPixels(this.chartType, this.chartDataController.getCountPoints(), printParams),
            (pagesData) => {
                this.pdfGenerator.generatePDF({
                    pagesData: pagesData,
                    totalValue: this.chartDataController.getTotal(),
                    chartType: this.chartType,
                    pdfPrintParameters: printParams,
                    selectedParameters: this.selectedParameters,
                    selectorsData: this.selectorsData,
                    dateFormat: this.dateFormat,
                    includeOtherUsers: this.includeOtherUsersChecker(),
                    useStackColumns: this.useStackColumnsChecker(),
                    reportAuthorizationInfo: this.reportAuthorizationInfo,
                })
            },
            printParams.barsOnPage
        );
    },

    onDownloadPDFBtnClicked: function()
    {
        if (!this.downloadPDFBtnEnabled)
            return;

        this.pdfSettingsPreview.sendSaveChartPrintParametersRequest();
        this.pdfGenerator.downloadPDF();
    },

    onGeneratePDFCompleted: function ( pdfData )
    {
        this.pdfViewer.showPDF(pdfData);
        this.enableDownloadPDFButton();
    },

    _calculateTotalNumberOfPages: function(printParameters) {
        return getTotalPagesCalculator(this.chartType).getTotalNumberOfPages(this.chartDataController.getCountPoints(), printParameters)
    }
});

export default CreateChartLightboxPDFPreviewViewController


// WEBPACK FOOTER //
// ./web/js/reports/charts/CreateChartLightboxPDFPreviewViewController.js